import { MENU_CHANNELS, MENU_FULFILLMENT_TYPES } from '../constants.js';
import { BaseMenuEntityConfiguration } from '../entityConfigs/index.js';
export default new BaseMenuEntityConfiguration({
    consumable: false,
    filters: [
        {
            name: 'fulfillmentType',
            options: MENU_FULFILLMENT_TYPES,
            type: 'Select',
        },
        {
            name: 'channels',
            options: MENU_CHANNELS,
            type: 'Select',
        },
    ],
    hasDescription: true,
    hasHours: true,
    hasImage: true,
    hasVariations: false,
    hasPos: true,
    hasPresentation: true,
    lists: [
        {
            collection: 'Item',
            name: 'items',
            primaryRelationship: true,
        },
        {
            collection: 'Category',
            name: 'upsellCategories',
        },
    ],
    name: 'Category',
    options: {
        channels: ['pos', 'online', 'marketplace'],
        excludeFromThrottle: false,
    },
    pluralizedName: 'Categories',
    sellable: false,
    sortKeys: [],
    unlinkedOptions: [],
    version: 9,
});
//# sourceMappingURL=category.js.map